import { apiGetOneOrNull, apiPatch } from '@/core/api/resources'
import { trackSettingsWrite } from '@/core/api/settingsWrites'

const DEFAULT_ECN_STANDARD_UE = 2

export async function getEcnStandardUe(organisationId: string): Promise<number> {
  const row = await apiGetOneOrNull('/organisation/{id}', { id: organisationId })
  const value = row?.ecn_standard_ue
  return typeof value === 'number' && value >= 1 && value <= 4 ? value : DEFAULT_ECN_STANDARD_UE
}

export function updateEcnStandardUe(organisationId: string, value: number): Promise<void> {
  return trackSettingsWrite(async (identity) => {
    await apiPatch('/organisation/{id}', { id: organisationId }, { ecn_standard_ue: value }, identity)
  })
}
